import { useLocation, useNavigate } from "react-router-dom";
import { Lock, X } from "lucide-react";
import { pageLabelFor } from "../lib/searchCatalog";

// What ProtectedRoute leaves behind when it sends someone back to the dashboard (Ordre 24-4): a plain sentence instead of a silent redirect,
// so the person knows the page exists, that the missing access is the reason, and whom to ask. Dismissing it clears the router state.
export default function AccessNotice() {
  const location = useLocation();
  const navigate = useNavigate();
  const denied = location.state?.denied;
  if (!denied?.path) return null;
  const label = pageLabelFor(denied.path);
  const what = label ? `la page « ${label} »` : "cette page";
  const message = denied.reason === "feature"
    ? `${what.charAt(0).toUpperCase()}${what.slice(1)} n'est pas activée sur cette installation.`
    : `Vous n'avez pas accès à ${what}. Si vous en avez besoin, demandez l'accès à un administrateur.`;
  return (
    <div className="flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 text-sm text-amber-900" role="status" data-testid="access-notice">
      <Lock size={16} className="mt-0.5 shrink-0" aria-hidden />
      <span className="min-w-0 flex-1">{message}</span>
      <button type="button" aria-label="Fermer ce message" onClick={() => navigate(location.pathname, { replace: true, state: null })} className="rounded p-1 hover:bg-amber-100" data-testid="access-notice-close">
        <X size={14} />
      </button>
    </div>
  );
}
